import { useEffect } from 'react';
import { GATE_VIEW, getGateView } from './gateView';
import { ensureProfile } from './session';
import { useSession } from './useSession';

// For pages open to everyone that behave differently for a signed-in user of a
// Portal (unlike the Auth Gate, nobody is sent away). Waits for the Session to
// be restored, so `isChecking` is true until the answer is known.
export function useSignedIn(portal) {
  const session = useSession();
  const view = getGateView(session, portal);

  useEffect(() => {
    ensureProfile(portal);
  }, [portal]);

  return {
    isChecking: view === GATE_VIEW.LOADING,
    isSignedIn: view === GATE_VIEW.CONTENT,
  };
}
